import {
  REWARD_POOL_TICKET_CURRENCY,
  RewardPool,
  RewardPoolTicketCurrencyType,
} from '@shared/api/types/rewardPools';
import { concatCurrencyToAmount } from '@shared/helpers/formatters/concatCurrencyToAmount';

import { formatReward } from '@ui/uikit/utils';

type GetSignMessageProps = {
  rewardPool: RewardPool;
  entryAmount: number;
  currencyType: RewardPoolTicketCurrencyType;
};

export const getSignMessage = ({
  rewardPool,
  currencyType,
  entryAmount,
}: GetSignMessageProps): string => {
  const usingPart =
    currencyType.currency === REWARD_POOL_TICKET_CURRENCY.FREE
      ? `using ${entryAmount} free tickets`
      : `using ${concatCurrencyToAmount(
          formatReward(entryAmount * currencyType.price),
          currencyType.currency,
          {
            stableToDollar: false,
          },
        )} from your MagicID`;

  return `Buy ${entryAmount} ticket/s to participate in ${rewardPool.name} ${usingPart}`;
};
